import React from 'react';
import TimeAgo from 'react-timeago';
import spinner from '../images/spinner.gif';
import '../App.css';

export default class Neighbors extends React.Component {

  constructor(props) {
    super(props);
    this.state = {showModal: true, neighbors: [], isFetching: false};
  }

  async getNeighborList() {
    if (this.state.isFetching) {
      return;
    }
    if (this.state.totalNeighbors && this.state.neighbors.length >= this.state.totalNeighbors) {
      this.setState({isFetching: false});
      return;
    }
    let that = this;
    let page = this.state.page || 1;
    let url = window.location.protocol + '//' + window.location.host;
    this.setState({isFetching: true}, async function() {
      console.log(` Request URL: ${url}/api/v1/areas/${this.props.area._id['$oid']}/users?per_page=50&page=${page}`);
      const d = await fetch(`/api/v1/areas/${this.props.area._id['$oid']}/users?per_page=50&page=${page}`);
      d.json().then(data => {
        if (data) {
          let neighbors = that.state.neighbors;
          if (data && data['users']) {
            neighbors = neighbors.concat(data['users']);
            let totalNeighbors = data['meta']['total_count'];
            that.setState({totalNeighbors: totalNeighbors, neighbors: neighbors, page: (page + 1), isFetching: false});
          }
        } else {
          console.log('Got nothing: err is: ' + err);
        }
      });
    });
  }

  isBottom(el) {
    if (el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    } else {
      return true;
    }
  }

  componentDidMount() {
    document.addEventListener('scroll', this.trackScrolling);
    this.getNeighborList();
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.trackScrolling);
  }

  trackScrolling = () => {
    const wrappedElement = document.getElementById('neighborsDiv');
    if (this.isBottom(wrappedElement)) {
      this.getNeighborList();
      // Get more users..
      if ( this.state.neighbors.length >= this.state.totalNeighbors ) {
        document.removeEventListener('scroll', this.trackScrolling);
      }
    }
  };

  showProfile(e, user) {
    console.log('[Neighbors] showProfile called with user: ' + user);
    e.preventDefault();
    if (e.target.id !== 'chat') {
      console.log('[Neighbors] target id is not chat...');
      this.props.app.showProfile(user);
    }
  }

  hideModal() {
    this.props.app.setState({showInviteModal: false});
  }

  addToConversation(conversation, username) {
    this.props.closeMe();
    this.props.app.addToConversation(conversation, username);
  }

  async search(e) {
    if (e) e.preventDefault();
    // Do complete search here..
    let query = this.state.searchString;
    if (this.state.isFetching) {
      return;
    }
    if (this.state.totalResults && this.state.results.length >= this.state.totalResults) {
      this.setState({isFetching: false});
      return;
    }
    let that = this;
    let searchPage = this.state.searchPage || 1;
    if (this.state.lastSearch && this.state.lastSearch !== query) {
      searchPage = 1;
    }
    let url = window.location.protocol + '//' + window.location.host;
    let neighbors = this.state.neighbors;
    if (searchPage === 1) {
      // Clear out neighbors list..
      neighbors = [];
    }
    this.setState({isFetching: true, searchPage: searchPage}, async function() {
      console.log(` Request URL: ${url}/api/v1/users/search?q=${query}&page=${searchPage}`);
      const d = await fetch(`${url}/api/v1/users/search?q=${query}&page=${searchPage}&per_page=50`);
      d.json().then(data => {
        console.log(' DATA: ' + data);
        if (data) {
          console.log('[Neighbors] Search resuls: ' + JSON.stringify(data));
          // let neighbors = that.state.neighbors;
          if (data?.users) {
            neighbors = neighbors.concat(data.users);
            let totalResults = data['meta']['total_count'];
            that.setState({totalResults: totalResults, neighbors: neighbors, searchPage: (searchPage + 1), isFetching: false, lastSearch: query});
            that.props.app.setState({searching: false});
          }
        } else {
          console.log('[Neighbors] Got error from search: err is: ' + err);
        }
      });
    });
  }

  render() {
    window.scrollTo(0, 0);
    let spinnerObj = '';
    if (this.state.isFetching) {
      spinnerObj = <img className='spinner' src={spinner} alt='' />;
    }
    let totalNeighbors = this.state.totalNeighbors || '';
    let neighbors = this.state.neighbors;
    let userElements = [];
    for (let i = 0; i < neighbors.length; i++) {
      let rowClass = i % 2 ? 'row' : 'rowGrey';
      let messageButton = ''; // Note this will be different for Neighbor list vs add-to-conversation
      if (neighbors[i].username !== this.props.app.state.user.username) {
        if (this.props.isModal) {
          messageButton = <button key={neighbors[i].username} type='submit' id='chat' className='smallSubmitButton'
                                  onClick={(e) => {if (e.target.id === 'chat') {console.log(' CLICK 1 '); this.addToConversation(undefined, neighbors[i].username)}}}>Adicionar</button>
        } else {
          messageButton = <button key={neighbors[i].username} type='submit' id='chat' className='smallSubmitButton'
                                  onClick={(e) => {if (e.target.id === 'chat') {console.log(' CLICK 2'); this.props.app.showConversations(neighbors[i].username)}}}>Mensagem</button>
        }
      }
      userElements.push(
        <div onClick={(e) => this.showProfile(e, neighbors[i])} key={neighbors[i]._id['$oid']} className={rowClass} style={{padding: '8px', height: '35px'}}>
          <img className='avatarLeft' src={neighbors[i].avatar} alt='' />
          <div key={neighbors[i]._id['$oid']} className='rowField' style={{width: '120px', padding: '6px'}}>
            {neighbors[i].username}
          </div>
          <div className='rowField' style={{fontSize: '11px', padding: '6px'}}>Joined <TimeAgo date={neighbors[i].created_at} /></div>
          {messageButton}
        </div>
      );
    }
    let neighborBottom = <div id='neighborsDiv' className='neighborsDiv'>
      {userElements}
    </div>;
    let addStyle = {};
    if (this.props.isModal) {
      addStyle['margin'] = 0;
      addStyle['padding'] = 0;
      addStyle['width'] = '524px';
    }
    return(
      <div className='timeline' style={addStyle}>
        <div className='postTitleText' style={{paddingLeft: '14px', paddingBottom: '8px'}}>
          {this.props.area.name} ({totalNeighbors})
              <div className='member_search'>
                 <form onSubmit={(e) => this.search(e)}>
                   <input placeholder='Procurar' type='text' onChange={(e) => this.setState({searchString: e.target.value})} value={this.state.searchString || ''} />
                 </form>
              </div>
          { this.props.isModal ? <div className='rightFloater'><span className='fakeLink' onClick={(e) => this.props.closeMe(e)}>[X]</span></div> : ''}
          {spinnerObj}
        </div>
        {neighborBottom}
      </div>
    );
  }
}
